import { reactive } from 'vue';
import firebase from 'firebase/compat/app';
import NewarcUser from './classes/User';
import { COLLECTION_USER, COLLECTION_LIKED_ADS, COLLECTION_WEBSITE_ADS } from './app_const';
import { listAdsByIds } from './services/websiteAdsV2';
import { readWithReconnect, withTimeout } from './services/firestoreRead';
import LikedAd from './classes/LikedAd';
import WebsiteAd from './classes/WebsiteAd';
import { functionsEurope, storage, googleClientId } from './firebase/init';
import { requestGoogleAccessToken } from './services/googleIdentity';
import { trackEvent } from './services/analytics';
import { trackAdSave, trackAdUnsave } from './services/stats';
import { needsCompanyLink } from './services/companyLink.js';
import { isEmbedded, embedderBrand } from './utils/trustedOrigins.js';

import {

  ref,
  getDownloadURL
} from 'firebase/storage';
import { httpsCallable } from 'firebase/functions';
import { platformAccountMessage } from './services/loginCode.js';


export const globalStore = reactive({
  isLoggedIn: false,
  newarcUser: null,
  currentUser: null, 
  likedAds: [],
  websiteAdsLiked: [],
  menuItems: [
      { id: 'case-salvate', label: 'Case salvate', icon: 'saved-houses.svg', 'route': '/user/favorite' },
      // { id: 'ristrutturazioni', label: 'Le tue ristrutturazioni', icon: 'ristrutturazioni.svg', 'route': '/annunci' },
      { id: 'newarc-ping', label: 'Ping!', icon: 'ping.svg', 'route': '/user/ping' },
      { id: 'preventivi', label: 'Preventivi richiesti', icon: 'preventivi.svg', 'route': '/user/preventivi-ristrutturazione' },
      { id: 'videochiamate', label: 'Le mie videochiamate', icon: 'videocall.svg', 'route': '/user/videochiamate' },
      // { id: 'configurazioni', label: 'Configurazioni', icon: 'configurazioni.svg', 'route': '/user/configuration' }, // nascosto momentaneamente
      // { id: 'valuta-immobile', label: 'Valuta immobile', icon: 'valutazioni.svg', 'route': '/annunci' },
      // { id: 'segnala-guadagna', label: 'Segnala e guadagna', icon: 'segnala.svg', 'route': '/annunci' },
  ],
  userMenuItems: [
      { id: 'profilo', label: 'Profilo', icon: 'profilo.svg', 'route': '/user/profile' }
  ],

  projectStatueData: {
    'Progetto': "Gli immobili di questo tipo sono case ancora da ristrutturare, per le quali esiste un progetto pronto ad essere realizzato. Su questi immobili puoi personalizzare la ristrutturazione e farla su misura per te. Contattaci e chiedi un preventivo di ristrutturazione gratuito! ", 
    'In ristrutturazione': "Gli immobili di questo tipo sono case in fase di ristrutturazione completamente personalizzabili nella scelta dei materiali, delle finiture e delle decorazioni.", 
    'Completata': "Gli immobili di questo tipo sono case già ristrutturate e subito pronte per essere abitate. Puoi ancora personalizzare le decorazioni, gli arredi e la cucina.",
    'Già ristrutturato': "Gli immobili di questo tipo sono case già ristrutturate e subito pronte per essere abitate. Puoi ancora personalizzare le decorazioni, gli arredi e la cucina.",
    'Progetto Newarc': "Il progetto e/o i lavori effettuati per questo immobile sono stati realizzati direttamente dai nostri architetti e dalle nostre ditte partner.",
    'Partner verificato': "Il progetto e i lavori effettuati per questo immobile sono stati realizzati da un partner di cui possiamo confermare la professionalità e la qualità.",
    'Nuova costruzione': "Gli immobili di questo tipo sono case di nuova realizzazione, che possono essere ancora in fase di completamento oppure pronte per essere abitate. Contatta l’agenzia o il costruttore!",
    'Nuova distribuzione': "Per questo immobile i nostri progettisti hanno proposto una nuova distribuzione degli spazi: planimetria e render mostrano il nuovo layout.",
  },
  zones: ["Campidoglio", "Colle della Maddalena", "San Secondo", "Pozzo Strada", "Crocetta", "San Salvario - Baretti", "Sassi", "Parella", "Lingotto", "Piazza Solferino", "Quadrilatero Romano", "Cavoretto", "Madonna del Pilone", "Superga", "Via della Rocca", "Santa Rita", "Via Roma", "Cit Turin", "San Donato", "Mirafiori Nord", "Gran Madre - Crimea", "San Salvario - Dante", "San Paolo", "Cenisia", "Nizza Millefonti", "Regio Parco", "Cittadella", "Città Giardino", "Vanchiglia", "Vanchiglietta", "Centro Europa", "Giardini Reali", "Italia 61"],
  composeProjectCode: {
    'region': {
      'Liguria': "00",
      'Piemonte': '01', 
      'Lombardia': '02', 
      'Lazio': '03',
      'Campania': '04',
      'Sicilia': '05',
      'Veneto': '06',
      'Emilia-Romagna': '07',
      'Toscana': '08',
      'Puglia': '09',
      'Calabria': '10',
      'Sardegna': '11',
      'Marche': '12',
      'Abruzzo': '13',
      'Friuli-Venezia Giulia': '14',
      'Trentino-Alto Adige': '15',
      'Umbria': '16',
      'Basilicata': '17',
      'Molise': '18',
      'Valle d\'Aosta': '19',
    },
    'project': {
      'ristrutturazione': 'RI',
      'subito': 'SU',
      'insieme': 'IN',
      'immagina': 'IM'
    }
  },
  regionToCityConverter: {
    'Piemonte': 'Torino',
    'Lombardia': 'Milano',
    'Lazio': 'Roma',
  },
  cityToRegionConverter: {
    'Torino': 'Piemonte',
    'Milano': 'Lombardia',
    'Roma': 'Lazio',
  }
});



export async function _logoutUser()  {
  await firebase.auth().signOut();
  globalStore.newarcUser = null;
  globalStore.currentUser = null;
  globalStore.isLoggedIn = false;
  

}

export async function getUserDetails( callLiked = false ) {
  const firebaseUser = firebase.auth().currentUser;

  if (!firebaseUser || !firebaseUser.uid) {
    // User is not logged in
    globalStore.currentUser = null;
    globalStore.isLoggedIn = false;
    globalStore.newarcUser = null;
    return;
  }

  globalStore.currentUser = firebaseUser;

  let card = await findUserCard(firebaseUser.uid);

  // #766: a signed-in account without its card (an Auth account whose card was
  // never written, or a Google sign-in interrupted before it) gets one from the
  // server. Once per account and page load: a platform account is refused, and
  // this runs on every call.
  if (!card.exists && !firebaseUser.isAnonymous && !cardRepairsTried.has(firebaseUser.uid)) {
    cardRepairsTried.add(firebaseUser.uid);
    // #3234: the same call creates the card with this site's relationship.
    companyLinksTried.add(firebaseUser.uid);
    try {
      await ensureMyWebClientCard(firebaseUser);
      card = await findUserCard(firebaseUser.uid);
    } catch (e) {
      // Refused (platform account), not deployed yet or offline: the session
      // stays without a site profile, as before.
    }
  }

  // #888: a platform account (staff, agency, professional) never stays signed
  // in to the site. The server already refuses its new sign-ins; this closes a
  // session opened before. A legacy website card has no type.
  const cardType = card.exists ? card.data().type : undefined;
  if (cardType && cardType !== 'web-client') {
    await _logoutUser();
    return;
  }

  if (card.exists) {
    // #3234: the relationship with the company of this site, once per page
    // load and without waiting (a refusal or an older server change nothing).
    // The callable directly, not ensureMyWebClientCard(): the card exists, so
    // there is no claim to wait for.
    // Inside an iframe whose embedding page is unknown, no call: the
    // relationship would go to the wrong company.
    const brand = pageBrand();
    if (brand && !firebaseUser.isAnonymous && !companyLinksTried.has(firebaseUser.uid)
        && needsCompanyLink(card.data(), brand)) {
      companyLinksTried.add(firebaseUser.uid);
      httpsCallable(functionsEurope, 'ensureMyWebClientCard')({ brand }).catch(() => {});
    }

    globalStore.isLoggedIn = true;
    globalStore.newarcUser = new NewarcUser(card.id, card.data());
    // #733 review: the sign-up's own wait ends with the page that ran it (the
    // login modal's iframe, a reload), so each session load of a website account
    // checks its token again. The doc's own type, as setWebClientClaim reads it:
    // NewarcUser turns a missing one into 'web-client'.
    if (card.data().type === 'web-client') refreshUntilWebClientClaim(firebaseUser);
    
    if( callLiked ) await getLikedAds(card.id);

  } else {
    globalStore.isLoggedIn = false;
    globalStore.newarcUser = null;
  }
}

// #732: website access in the Firestore / Storage rules keys on the server-set
// `webClient` claim, which `setWebClientClaim` (cloud-functions) sets a few
// seconds AFTER the sign-up creates the `users` doc. The new session's token was
// minted before, so without a refresh it lacks the claim for up to an hour, and
// once newarc-platform#2472 makes the platform predicate a positive claim, the
// Storage paths open only to `webClient` (profilePictures/, users/) fail in the
// meantime. Refresh until the claim is there, with growing delays (about 50 s in
// all), then give up: the SDK's hourly refresh still applies. Callers start it in
// the background and never wait on it; it never throws.
// The sign-ups start it, and so does getUserDetails for a session loaded without
// the claim; one wait per signed-in user object (a later call returns false),
// and a cached token that already has the claim is never refreshed.
const webClientClaimWaits = new WeakSet();

export async function refreshUntilWebClientClaim( user, delaysMs = [1000, 2000, 3000, 5000, 8000, 13000, 21000] ) {
  if (!user || typeof user.getIdTokenResult !== 'function') return false;
  if (webClientClaimWaits.has(user)) return false;
  webClientClaimWaits.add(user);
  try {
    const cached = await user.getIdTokenResult();
    if (cached?.claims?.webClient === true) return true;
  } catch (e) {
    // Refresh anyway.
  }
  for (const delay of delaysMs) {
    await new Promise((resolve) => setTimeout(resolve, delay));
    try {
      const result = await user.getIdTokenResult(true);
      if (result?.claims?.webClient === true) return true;
    } catch (e) {
      // Next attempt.
    }
  }
  return false;
}

// The account's `users` card: `users/{uid}`, the only place a card lives since
// newarc-cloud-functions#394 moved the older random-id ones (newarc-platform#2916).
// With the client offline a document read rejects where the former query answered
// empty from the cache: that answer is kept, so an unreachable Firestore still
// ends as "no card" (repair, then signed out) and never as an error in the
// sign-in flows (immaginacasa-site#903 review, L1). Other errors still throw.
function findUserCard( uid ) {
  return firebase.firestore()
    .collection(COLLECTION_USER)
    .doc(uid)
    .get()
    .catch((error) => {
      if (error?.code === 'unavailable') return { exists: false };
      throw error;
    });
}

// Accounts getUserDetails already tried to give a card to, in this page load.
const cardRepairsTried = new Set();
// #3234: accounts already asked for the relationship with this site's company,
// in this page load.
const companyLinksTried = new Set();
// Calls in flight, by uid: the Google sign-in and the getUserDetails of a page
// mounted meanwhile ask once.
const cardEnsures = new Map();

// #766: the card of the signed-in account is created by the server
// (newarc-cloud-functions#392, `ensureMyWebClientCard`) in `users/{uid}`, from
// the Auth record (email, name, photo); an existing card is left as it is.
// Throws the callable's error. When the call has just set the `webClient`
// claim the token is refreshed at once, otherwise the usual wait for it starts.
export function ensureMyWebClientCard( firebaseUser ) {
  const uid = firebaseUser.uid;
  if (!cardEnsures.has(uid)) {
    const call = (async () => {
      // #3234: the embedding page's brand when known (newarc.it's header).
      const { data } = await httpsCallable(functionsEurope, 'ensureMyWebClientCard')({ brand: pageBrand() || currentBrand() });
      if (data?.claim === 'stamped') {
        try {
          await firebaseUser.getIdToken(true);
        } catch (e) {
          // The next token refresh picks it up.
        }
      } else {
        refreshUntilWebClientClaim(firebaseUser);
      }
      return data;
    })();
    cardEnsures.set(uid, call);
    call.then(() => cardEnsures.delete(uid), () => cardEnsures.delete(uid));
  }
  return cardEnsures.get(uid);
}

// First Google access gets the same `users` card as the email sign-up, so the
// rest of the app (header pill, profile page, liked ads…) works unchanged. The
// server writes it (ensureMyWebClientCard), with name, surname and avatar taken
// from the Google profile. Returns the NewarcUser (existing or created).
export async function ensureUserDocFromGoogle( firebaseUser ) {
  const existing = await findUserCard(firebaseUser.uid);
  if (existing.exists) {
    return new NewarcUser(existing.id, existing.data());
  }

  await ensureMyWebClientCard(firebaseUser);
  const created = await findUserCard(firebaseUser.uid);
  if (!created.exists) {
    throw new Error('users card not found after ensureMyWebClientCard');
  }
  return new NewarcUser(created.id, created.data());
}

// "Accedi con Google" (#3141). The Google token comes from Google Identity
// Services, asked for straight from the click (popup gesture), then Firebase
// signs in with it. Errors (incl. auth/account-exists-with-different-credential
// and popup-closed-by-user) bubble up to the caller for messaging.
export async function signInWithGoogle() {
  const accessToken = await requestGoogleAccessToken(googleClientId);
  const firebaseUser = await signInWithGoogleToken(accessToken);
  let newarcUser;
  try {
    newarcUser = await ensureUserDocFromGoogle(firebaseUser);
  } catch (error) {
    // #766: the server refuses this account a site card (a platform account,
    // a disabled one): the Google session must not stay open. The caller
    // shows the server message.
    if (String(error?.code || '').replace(/^functions\//, '') === 'failed-precondition') await _logoutUser();
    throw error;
  }
  return { firebaseUser, newarcUser };
}

// #888: the server sees the token first, so Firebase never gets a Google
// sign-in for a platform account (it would unlink the password of an
// unverified email): the server refuses it (`platform-account`, with its
// platform in `details.brand`), uses an existing site account, or creates a
// new one with its card (#3141, client sign-ups are disabled). Then the same
// token signs in.
async function signInWithGoogleToken(accessToken) {
  const credential = firebase.auth.GoogleAuthProvider.credential(null, accessToken);
  try {
    await httpsCallable(functionsEurope, 'createGoogleWebClientAccount')({ accessToken, brand: currentBrand() });
  } catch (error) {
    if (error?.details?.reason === 'platform-account') {
      throw Object.assign(new Error(platformAccountMessage(error.details.brand)), {
        code: error.code,
        details: error.details,
        cause: error,
      });
    }
    // A server older than newarc-cloud-functions#494 answers this for an
    // existing account: sign in to it.
    if (webAccountErrorReason(error) !== 'email-in-use') {
      if (error?.details?.reason) throw error;
      // Unreachable or missing callable: its bare message ("internal") is
      // not for the user. Every Google sign-in needs it, so it fails closed.
      throw Object.assign(new Error('Accesso con Google non riuscito. Riprova.'), {
        code: 'auth/internal-error',
        cause: error,
      });
    }
  }
  try {
    return (await firebase.auth().signInWithCredential(credential)).user;
  } catch (error) {
    // Still refused although the server answered. The cause is unverified, so
    // no guess is shown: a neutral error (a synthetic Firebase-style code, so
    // the callers need no change) that keeps the original as `cause`.
    if (error?.code !== 'auth/admin-restricted-operation') throw error;
    throw Object.assign(new Error('Accesso con Google non riuscito. Riprova.'), {
      code: 'auth/internal-error',
      cause: error,
    });
  }
}

const PROFILE_PICTURE_TIMEOUT_MS = 5000;

export async function userProfile( userId ){

  const db = firebase.firestore();
  
  const userRef = await db
    .collection(COLLECTION_USER)
    .doc( userId )
    .get();

  

  if (userRef.exists ) {
    
    const userProfile = new NewarcUser(userRef.id, userRef.data());
    // const storage = getStorage();

    // Awaited (#870): callers render the profile right away, so a URL set
    // later on the plain object never reaches the view. On failure clear it
    // so the bare file name is not rendered as a broken image. Storage retries
    // unreachable/5xx requests for up to 2 minutes: cap the wait (#871).
    const picture = userProfile.profilePicture?.trim();
    userProfile.profilePicture = '';
    if (picture) {
      try {
        userProfile.profilePicture = await withTimeout(
          () => getDownloadURL(ref(storage, `users/${userId.trim()}/${picture}`)),
          PROFILE_PICTURE_TIMEOUT_MS
        );
      } catch (e) {
        // No avatar: the v-if hides the img.
      }
    }

    return userProfile;

  } 
  
  return null;

}


export async function getLikedAds(userId) {
  const db = firebase.firestore();
  globalStore.likedAds = [];

  var ids = [];

  const likeRef = await db
    .collection(COLLECTION_LIKED_ADS)
    .where('userId', '==', userId)
    .get();

  if (!likeRef.empty) {
    for (const doc of likeRef.docs) {
      const likedAdObj = new LikedAd(doc.id, doc.data());

      const likedAd = globalStore.likedAds.find(
        ad => ad.userId === userId && ad.newarcHomeId === likedAdObj.newarcHomeId
      );
      if( !likedAd ) {
        ids.push( likedAdObj.newarcHomeId);
        globalStore.likedAds.push(likedAdObj);
      }
      
    }
  }

  if( ids.length > 0 ) await getWebsiteAdsLiked(ids);

}



// #614: the v2 read path is the only one — this stays as the single entry
// point the callers already use. The v1 collection is still reached from
// getWebsiteAdsLikedV2, but only as a per-id fallback.
export async function getWebsiteAdsLiked( ids ) {
  await getWebsiteAdsLikedV2(ids);
}

// #487: liked ads on the v2 read path. Ads not (yet) in websiteAdsV2 —
// not migrated, or multi-unit (gap G2) — fall back to the v1 collection so
// no existing like disappears during the transition.
export async function getWebsiteAdsLikedV2( ids ) {
  globalStore.websiteAdsLiked = [];

  const wanted = (ids || []).filter(Boolean);
  if (wanted.length === 0) return;

  // #736: dopo che il tab è stato sospeso la lettura può restare appesa.
  const adsV2 = await readWithReconnect(() => listAdsByIds(wanted));
  const found = new Set(adsV2.map((ad) => ad.sourceId));
  const missing = wanted.filter((id) => !found.has(id));

  const legacyAds = [];
  if (missing.length > 0) {
    const db = firebase.firestore();
    // Firestore `in` queries are capped (10 in older SDKs); chunk to stay safe.
    for (let i = 0; i < missing.length; i += 10) {
      const chunk = missing.slice(i, i + 10);
      const likeRef = await db
        .collection(COLLECTION_WEBSITE_ADS)
        .where('newarcHomeId', 'in', chunk)
        .get();
      likeRef.forEach((doc) => legacyAds.push(new WebsiteAd(doc.data())));
    }
  }

  globalStore.websiteAdsLiked = [...adsV2, ...legacyAds];
}

export function isAdLiked( userId, newarcHomeId ) {
  return globalStore.likedAds.some(ad => ad.userId === userId && ad.newarcHomeId === newarcHomeId);
}

export async function handleLikeAd(userId, newarcHomeId) {
  const likedAd = globalStore.likedAds.find(
    ad => ad.userId === userId && ad.newarcHomeId === newarcHomeId
  );

  const likedWebsiteAd = globalStore.websiteAdsLiked.find(
    ad => ad.newarcHomeId === newarcHomeId
  );

  if (likedAd) {
    
    await unlikeAd(likedAd.firebaseId); // Remove from Firestore
    const index = globalStore.likedAds.indexOf(likedAd);
    if (index !== -1) globalStore.likedAds.splice(index, 1); // Remove from list

    const _index = globalStore.websiteAdsLiked.indexOf(likedWebsiteAd);
    if (_index !== -1) globalStore.websiteAdsLiked.splice(_index, 1); // Remove from list
    // Statistiche di prima parte (#652): l'agenzia non è nota qui.
    trackAdUnsave({ adId: newarcHomeId });

  } else {

    const newAdId = await likeAd(userId, newarcHomeId); // Save to Firestore and get the new ID
    globalStore.likedAds.push(new LikedAd(newAdId, { userId, newarcHomeId }));
    // GA4 (#501): fired only on a LIKE (not unlike). ad_id is the registered
    // dimension; the docId is the ad's sourceId.
    trackEvent('ad_like', { ad_id: newarcHomeId });
    // Statistiche di prima parte (#652).
    trackAdSave({ adId: newarcHomeId });
  }

}

export async function likeAd(userId, newarcHomeId) {
  const db = firebase.firestore();

  const existsRef = await db.collection(COLLECTION_LIKED_ADS)
  .where('userId', '==', userId)
  .where('newarcHomeId', '==', newarcHomeId)
  .limit(1)
  .get();

  if( existsRef.docs.length > 0 ) return existsRef.docs[0].id;

  const docRef = await db.collection(COLLECTION_LIKED_ADS).add({
    userId,
    newarcHomeId,
  });
  return docRef.id;
}

export async function unlikeAd(firebaseId) {
  const db = firebase.firestore();
  await db.collection(COLLECTION_LIKED_ADS).doc(firebaseId).delete();
}

export function isMobile() {
    if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return true
    } else {
      return false
    }
}

export function formattedDate(timestamp) {
    const date = timestamp ? new Date(timestamp) : new Date()
    
    return date.toLocaleDateString('it-IT', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    // hour: '2-digit',
    // minute: '2-digit'
    })
}

export function isValidEmail(email) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
}

// Brand derived from the website URL. A newarc.it (or similar, e.g.
// compra.newarc.it / newarc-staging) host is 'newarc'; everything else —
// immaginacasa.com and localhost included — is 'immaginacasa'.
export function currentBrand() {
  try {
    if (typeof window !== 'undefined' && window.location && /newarc/i.test(window.location.hostname)) {
      return 'newarc';
    }
  } catch (e) {
    // ignore — fall back to immaginacasa
  }
  return 'immaginacasa';
}

// #3234: the brand of the page the visitor is on. Outside an iframe it is
// currentBrand(); inside one (newarc.it's header opens /iLogin, which lands on
// immaginacasa.com) it is the brand of the embedding page, or null when that
// cannot be told reliably. Decides the company of a new account and the
// relationship asked for at login.
export function pageBrand(win = window) {
  if (!isEmbedded(win)) return currentBrand();
  return embedderBrand(win);
}

// Whether an account exists for the email, asked of the server
// (newarc-cloud-functions#455): signed out, the site no longer reads other
// people's `users` cards (#855, newarc-platform#2803). Yes/no only; the server
// normalises the email. Throws on any error (rate limit included): the callers
// then take the sign-up path.
export async function accountExistsForEmail( email ) {
  const { data } = await httpsCallable(functionsEurope, 'checkAccountEmail')({ email: String(email ?? '') });
  return data?.exists === true;
}

export async function updateUserInfo( data ) {
  const db = firebase.firestore();
  
  try {
    await db.collection(COLLECTION_USER)
    .doc(globalStore.newarcUser.firebaseId)
    .update(data);
    return true;
  } catch (error) {
    return false;
  }
  


  
}

/**
 * Creates a website account through the server (#766,
 * newarc-cloud-functions#392 `createWebClientAccount`): Auth account and
 * `users/{uid}` card in one call, with the email already verified by the
 * single-use proof of the code step (#666), which is mandatory. Then signs the
 * new account in with the custom token the call returns.
 * Without a password the server picks a random one and sends the "Crea la tua
 * password" email itself.
 * Throws the callable's error: webAccountErrorMessage turns it into a message.
 */
export async function createVerifiedWebAccount({ firstname, lastname, email, password = '', phone = '', proof, brand = currentBrand() }) {
  const cleanEmail = String(email ?? '').trim();
  const name = String(firstname ?? '').trim();
  const surname = String(lastname ?? '').trim();
  const { data } = await httpsCallable(functionsEurope, 'createWebClientAccount')({
    email: cleanEmail,
    proof,
    ...(password ? { password } : {}),
    name,
    surname,
    ...(phone ? { phone } : {}),
    brand,
  });
  if (!data?.customToken) throw new Error('createWebClientAccount without customToken');

  const { user } = await firebase.auth().signInWithCustomToken(data.customToken);
  // The server sets the claim before answering; if that failed, its trigger
  // sets it seconds later.
  refreshUntilWebClientClaim(user);

  const newarcUser = new NewarcUser(data.cardId, {
    id: data.uid,
    name,
    surname,
    email: cleanEmail,
    type: 'web-client',
    role: 'web-client',
    source: 'web',
    brand,
    profilePicture: '',
    phone,
  });
  return { user, newarcUser, verified: data.emailVerified === true };
}

// Why createWebClientAccount refused, from the HttpsError of the contract
// (`details.reason`, Auth codes in `details.originalError.code`):
// 'email-in-use' | 'weak-password' | 'proof-invalid' | 'invalid-data' |
// 'rate-limited' | 'email-busy' | 'unavailable' | 'other'.
export function webAccountErrorReason(error) {
  const code = String(error?.code || '').replace(/^functions\//, '');
  const reason = error?.details?.reason;
  const authCode = error?.details?.originalError?.code;
  if (code === 'already-exists' || reason === 'email-in-use' || authCode === 'auth/email-already-exists') return 'email-in-use';
  if (reason === 'weak-password' || authCode === 'auth/weak-password') return 'weak-password';
  if (reason === 'proof-invalid') return 'proof-invalid';
  if (code === 'invalid-argument') return 'invalid-data';
  if (code === 'resource-exhausted') return 'rate-limited';
  if (reason === 'email-busy') return 'email-busy';
  // `not-found`: the callable is missing, e.g. while it is being deployed.
  if (code === 'unavailable' || code === 'not-found' || code === 'deadline-exceeded') return 'unavailable';
  return 'other';
}

const WEB_ACCOUNT_MESSAGES = {
  'email-in-use': 'Esiste già un account con questa email',
  'weak-password': 'La password è troppo semplice: scegline una più lunga, con lettere e numeri.',
  'proof-invalid': 'Il codice di verifica è scaduto o è già stato usato: richiedine uno nuovo e riprova.',
  'invalid-data': 'Controlla nome, cognome ed email e riprova.',
  'rate-limited': 'Troppi tentativi: riprova tra qualche minuto.',
  'email-busy': 'Stiamo già creando un account con questa email: riprova tra qualche secondo.',
  'unavailable': 'Il servizio è momentaneamente non disponibile: riprova tra qualche minuto.',
  'other': 'Registrazione non riuscita. Riprova.',
};

export function webAccountErrorMessage(error) {
  return WEB_ACCOUNT_MESSAGES[webAccountErrorReason(error)];
}
